import { createContext } from 'react';
import { NeilsenTrackArgs, NielsenInit } from './neilsenTracker.js';

interface INielsenTrackingContext {
  nielsenTrack: (f: NeilsenTrackArgs) => void;
}

const defaultValue = {
  nielsenTrack: console.log,
};

export const TrackingContext = createContext<INielsenTrackingContext>(defaultValue);

export const Tracking = ({ children }: { children: JSX.Element }) => {
  const nielsenTrack = NielsenInit();
  return (
    <TrackingContext.Provider
      value={{
        nielsenTrack,
      }}
    >
      {children}
    </TrackingContext.Provider>
  );
};
